import { Component, OnInit } from '@angular/core';

@Component({
  selector: '[class="celerity-app"]',
  templateUrl: './agency-disabled.component.html'
})
export class AgencyDisabledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
